import React from "react";
import {
  Button,
  Col,
  Divider,
  List,
  message,
  Popconfirm,
  Row,
  Select,
  Spin,
  Tag,
  Tooltip,
} from "antd";
import { CloseOutlined } from "@ant-design/icons";
import {
  convertProviderTenantApiToList,
  convertProviderTenantListToApi,
} from "../../Helpers/ServiceProviderHelpers";
import { EntityStatus, rowLayout, colLayout } from "../../Constants/Constants";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { BreadCrumbs } from "../Common/BreadCrumbs";
import { apiCallback } from "../../ApiHandlers/Common";
import { selectAdvanceFilterFunction } from "../../Constants/Utilities";

class GroupServiceProvider extends React.Component {
  constructor(props) {
    super(props);
    console.log("GroupServiceProvider props", props);
    this.state = {
      tenantsToAdd: [],
      tenantList: [],
      existingTenants: [],
      fetchingTenants: false,
      addingTenants: false,
    };
  }
  componentDidMount() {
    this.fetchProviderTenantList();
  }

  getTenantList = (existTenants) => {
    const { providerData } = this.props;
    const existingTenants = existTenants || this.state.existingTenants;
    return providerData.filter(
      (item) =>
        item.type === "Tenant" &&
        !existingTenants.some((t) => t.providerId === item.providerId)
    );
  };

  fetchProviderTenantList = () => {
    const errorCallback = () => {
      const tenantList = this.getTenantList();
      this.setState({ tenantList, fetchingTenants: false });
      message.error("Error fetching Tenant list");
    };
    const successCallback = (data) => {
      const existingTenants = convertProviderTenantApiToList(data);
      const tenantList = this.getTenantList(existingTenants);
      this.setState({
        tenantList,
        fetchingTenants: false,
        existingTenants,
      });
    };
    try {
      this.setState({ fetchingTenants: true });
      const { history, record, serviceProviderGroupApi } = this.props;
      serviceProviderGroupApi.getServiceProviderTenants(
        record?.key,
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback(error);
    }
  };

  addTenantsToList = (tenantsToAdd) => {
    console.log("addTenantsToList", tenantsToAdd);
    const { existingTenants } = this.state;
    const newExistingTenants = existingTenants.concat(tenantsToAdd);
    const newTenantList = this.getTenantList(newExistingTenants);
    this.setState({
      existingTenants: newExistingTenants,
      tenantList: newTenantList,
    });
  };
  removeTenantFromList = (tenant) => {
    console.log("removeTenantFromList", tenant);
    const { existingTenants } = this.state;
    const newExistingTenants = existingTenants.filter(
      (item) => item.providerId !== tenant.providerId
    );
    this.setState({
      existingTenants: newExistingTenants,
      tenantList: this.getTenantList(newExistingTenants),
    });
  };

  handleChange = (value) => {
    this.setState({ tenantsToAdd: value });
  };

  onTenantAdd = () => {
    const {
      record: { key },
    } = this.props;
    const { tenantsToAdd } = this.state;
    console.log("onTenantAdd", key, tenantsToAdd);
    this.setState({ addingTenants: true });
    const errorCallback = (error) => {
      message.error("Error adding Tenants to Provider");
      this.setState({ addingTenants: false });
    };
    try {
      const tenantData = convertProviderTenantListToApi(tenantsToAdd);
      console.log("onTenantAdd tenantData", tenantData);
      this.props.serviceProviderGroupApi.updateServiceProviderTenants(
        key,
        tenantData,
        apiCallback({
          history: this.props.history,
          errorCallback,
          successCallback: (data) => {
            message.success(`Tenants added successfully`);
            this.setState({ addingTenants: false, tenantsToAdd: [] });
            this.fetchProviderTenantList();
          },
        })
      );
    } catch (error) {
      errorCallback();
    }
  };

  onTenantRemove = (item) => {
    const {
      record: { key },
    } = this.props;
    console.log("onTenantRemove", key, item);
    this.removeTenantFromList(item);
    const errorCallback = (error) => {
      message.error(`Error removing Tenant ${item.name}`);
      this.addTenantsToList([item]);
    };
    try {
      this.props.serviceProviderGroupApi.removeServiceProviderTenants(
        key,
        item.providerId,
        apiCallback({
          history: this.props.history,
          errorCallback,
          successCallback: () =>
            message.success(`Tenant ${item.name} removed successfully`),
        })
      );
    } catch (error) {
      errorCallback(error);
    }
  };

  render() {
    const { onActionClick, record, parentBread } = this.props;
    const {
      tenantList,
      existingTenants,
      tenantsToAdd,
      fetchingTenants,
      addingTenants,
    } = this.state;
    return (
      <div className="provider-group-container">
        <div className="page-header-container">
          <BreadCrumbs
            headers={parentBread.concat(`Service Provider Group`)}
            onParentActionClick={onActionClick(null, null)}
          />
        </div>
        <Divider className="divider" />
        <div className="page-parent-title-container">
          <label>Provider: {record.name}</label>
        </div>
        <Spin spinning={addingTenants} tip="Adding tenants, please wait...">
          <Row {...rowLayout} style={{ marginTop: "10px" }}>
            <Col {...colLayout} className="display-flex-column">
              <label className="section-title">Add Tenants:</label>
              <Select
                mode="multiple"
                className="tagged-dropdown"
                loading={fetchingTenants}
                style={{ width: "90%", maxWidth: "600px" }}
                placeholder={"Select Tenants"}
                value={tenantsToAdd}
                onChange={this.handleChange}
                filterOption={selectAdvanceFilterFunction("title")}
              >
                {tenantList.map((item) => (
                  <Select.Option
                    key={item.providerId}
                    title={item.name}
                    className="tagged-dropdown-options"
                    disabled={item.status === EntityStatus.INACTIVE}
                  >
                    {item.name}
                    <Tag
                      color={
                        item.status === EntityStatus.ACTIVE ? "green" : "red"
                      }
                    >
                      {item.status}
                    </Tag>
                  </Select.Option>
                ))}
              </Select>
              <Button
                type="primary"
                className="add-button"
                onClick={this.onTenantAdd}
              >
                Add
              </Button>
            </Col>
            <Col {...colLayout} className="display-flex-column">
              <label className="section-title header-label">Tenant List:</label>
              <List
                bordered
                className="data-list tenant-list"
                loading={fetchingTenants && { tip: "Loading Tenants..." }}
                dataSource={existingTenants}
                // locale={{ emptyText: "No Tenants" }}
                renderItem={(item) => (
                  <List.Item>
                    <div className="data-list-item">
                      {item.name}
                      <Tooltip title="Remove tenant">
                        <Popconfirm
                          okText="Yes"
                          cancelText="No"
                          title="Are you sure want to remove tenant?"
                          onConfirm={() => this.onTenantRemove(item)}
                        >
                          <CloseOutlined />
                        </Popconfirm>
                      </Tooltip>
                    </div>
                  </List.Item>
                )}
              />
            </Col>
          </Row>
        </Spin>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  serviceProviderGroupApi: state.apis.serviceProviderGroupApi,
});

const connectedGroupServiceProvider =
  connect(mapStateToProps)(GroupServiceProvider);

export default withRouter(connectedGroupServiceProvider);
